










import { Specification } from '~/models/classified/types'
import WantedBadge from '~/components/car/classifieds/badges/WantedBadge.vue'
import ForRentBadge from '~/components/car/classifieds/badges/ForRentBadge.vue'
import LeasingBadge from '~/components/car/classifieds/badges/LeasingBadge.vue'
import { defineComponent, PropType } from '~/utils/nuxt3-migration'

export default defineComponent({
  components: {
    WantedBadge,
    ForRentBadge,
    LeasingBadge
  },
  props: {
    specification: {
      type: Object as PropType<Specification>,
      required: true
    }
  }
})
